import {fetchAuthSession} from "aws-amplify/auth";
import {del, get, post, put} from "aws-amplify/api";
import axios from "axios";
import {MeasurementPoints, TemplateMetadata} from "../pages/app/types.ts";
import {Template} from "@pdfme/common";

const apiName = 'KMGCloud';

async function getIdToken() {
    try {
        const {idToken} = (await fetchAuthSession()).tokens ?? {};
        return idToken?.toString();
    } catch (error) {
        console.error('Error fetching auth session:', error);
        return null;
    }
}

async function getGroup() {
    try {
        const {accessToken} = (await fetchAuthSession()).tokens ?? {};
        const groups: any = accessToken?.payload['cognito:groups'] ?? "";
        return groups[0];
    } catch (error) {
        console.error('Error fetching auth session:', error);
        return null;
    }
}

export const api = {
    //Templates
    async getTemplates(sub: string): Promise<TemplateMetadata[]> {
        return new Promise(async (resolve, reject) => {
            try {
                const token = await getIdToken();
                const {body} = await get({
                    apiName: apiName,
                    path: '/templates',
                    options: {
                        headers: {
                            Authorization: token || ''
                        },
                        queryParams: {
                            sub,
                        },
                    }
                }).response;
                const raw = await body.json() as unknown;
                resolve(raw as TemplateMetadata[]);
            }
            catch (error) {
                reject(error);
            }
        });
    },

    async postTemplate(sub: string, name: string, template: Template, measurementPoints: MeasurementPoints[]): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try{
                const token = await getIdToken();
                const group = await getGroup();
                const {body} = await post({
                    apiName: apiName,
                    path: '/templates',
                    options: {
                        headers: {
                            Authorization: token ? token : ''
                        },
                        queryParams: {
                            sub: sub,
                            name: name,
                            group: group,
                        },
                    }
                }).response;
                const url = await body.json() as string;
                const data = {
                    template: template,
                    measurementPoints: measurementPoints,
                };
                await axios.put(url, JSON.stringify(data), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                resolve("Template created successfully");
            }
            catch (error) {
                reject(error);
            }
        })
    },

    async deleteTemplateById(sub: string, id: number): Promise<any>  {
        return new Promise(async (resolve, reject) => {
            try {
                const token = await getIdToken();
                await del({
                    apiName: apiName,
                    path: `/templates/${id}`,
                    options: {
                        headers: {
                            Authorization: token ? token : ''
                        },
                        queryParams: {
                            sub: sub,
                        },
                    }
                }).response;
                return resolve({ success: true });
            } catch (error) {
                reject(error);
            }
        });
    },

    async putTemplateById(sub: string, id: number, name: string, template: Template, measurementPoints: MeasurementPoints[]): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try{
                const token = await getIdToken();
                const group = await getGroup();
                const {body} = await put({
                    apiName: apiName,
                    path: `/templates/${id}`,
                    options: {
                        headers: {
                            Authorization: token ? token : ''
                        },
                        queryParams: {
                            sub: sub,
                            name: name,
                            group: group,
                        },
                    }
                }).response;
                const url = await body.json() as string;
                const data = {
                    template: template,
                    measurementPoints: measurementPoints,
                };
                await axios.put(url, JSON.stringify(data), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                resolve("Template updated successfully");
            }
            catch (error) {
                reject(error);
            }
        })
    },

    async getTemplateData(sub: string, id: number): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const token = await getIdToken();

                const { body } = await get({
                    apiName: apiName,
                    path: `/templates/${id}/data`,
                    options: {
                        headers: {
                            Authorization: token || ''
                        },
                        queryParams: { sub }
                    }
                }).response;

                const response = await body.json() as { presignedUrl: string };

                if (!response?.presignedUrl) {
                    return reject(new Error('Presigned URL not found in response'));
                }

                const data = await axios.get(response.presignedUrl);
                resolve(data.data);
            } catch (error) {
                reject(error);
            }
        });
    },

    //Prüfungen
    async getPruefungen(sub: string): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            try {
                const token = await getIdToken();
                const { body } = await get({
                    apiName: apiName,
                    path: `/pruefungen`,
                    options: {
                        headers: {
                            Authorization: token || ''
                        },
                        queryParams: { sub }
                    }
                }).response;
                const raw = await body.json() as unknown;
                resolve(raw as any[]);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },

    async deletePruefungById(id: number): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            try {
                const token = await getIdToken();
                const { body } = await del({
                    apiName: apiName,
                    path: `/pruefungen/${id}`,
                    options: {
                        headers: {
                            Authorization: token || ''
                        },body: {
                            PruefungsID: id
                        }
                    }
                }).response;
                const raw = await body.json() as unknown;
                resolve(raw as any[]);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}
